import axios from "axios";
import { jwtDecode } from "jwt-decode"; // npm install jwt-decode
import { store } from "../index.jsx";
import { handleLogout } from "../redux/authSlice.js";
import { notification } from "antd";

const axiosInstance = axios.create({
	baseURL: `${process.env.REACT_APP_BASE_URL}`,
	timeout: 60000,
	timeoutErrorMessage: "Request Connection timedout",
	headers: {
		"Content-Type": "application/json",
	},
});

let isRefreshing = false;

const isTokenExpired = (token) => {
	if (!token) return true;
	
	try {
		const decoded = jwtDecode(token);
		const currentTime = Date.now() / 1000;
		return decoded.exp < currentTime + 30;
	} catch (error) {
		console.error("Error decoding token:", error);
		return true; 
	}
};

axiosInstance.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("token");
		if (token && isTokenExpired(token)) {
			if (!isRefreshing) {
				isRefreshing = true;
				store.dispatch(handleLogout());
				notification.warning({
					message: "Session Expired",
					description: "Your session has expired. Please login again.",
					duration: 3,
				});
				setTimeout(() => {
					isRefreshing = false;
				}, 1000);
			}
			return Promise.reject(new Error("Token expired"));
		}
		
		if (token) {
			config.headers["Authorization"] = `Bearer ${token}`;
		}
		const state = store.getState();
		const organizationId = state?.auth?.currentOrganizationId;

		if (organizationId) {
			if (config.method?.toLowerCase() === 'get') {
				config.params = {
					...config.params,
					authOrgid: organizationId
				};
			} else {
				if (config.data) {
					if (typeof config.data === 'object' && config.data !== null) {
						config.data = {
							...config.data,
							organizationId: organizationId
						};
					} else if (typeof config.data === 'string') {
						try {
							const parsedData = JSON.parse(config.data);
							config.data = JSON.stringify({
								...parsedData,
								organizationId: organizationId
							});
						} catch (e) {
							config.data = JSON.stringify({
								data: config.data,
								organizationId: organizationId
							});
						}
					}
				} else {
					config.data = { organizationId: organizationId };
				}
			}
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

axiosInstance.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response?.status === 401) {
			const isLoginError = error.config?.url?.includes('/login') || 
								 error.response?.data?.message === "Invalid email or password";
			if (!isLoginError && !isRefreshing) {
				isRefreshing = true;
				
				store.dispatch(handleLogout());
				
				notification.warning({
					message: "Session Expired",
					description: error.response?.data?.message || "Your session has expired. Please login again.",
					duration: 3,
				});
				
				setTimeout(() => {
					isRefreshing = false;
				}, 1000);
			}
		}
		
		return Promise.reject(error);
	}
);

export default axiosInstance;